var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              !_vm.printMode
                ? [
                    _c(
                      "div",
                      { staticClass: "table-page-search-wrapper" },
                      [
                        _c(
                          "a-form",
                          {
                            attrs: { layout: "inline" },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.searchQuery.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "门店",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("store-tenant-select", {
                                          attrs: { domain: "capital" },
                                          on: {
                                            change: _vm.handleStoreTenantChange,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据编号",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入单据编号",
                                          },
                                          model: {
                                            value: _vm.queryParam.billNo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "billNo",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.billNo",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "往来单位",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择往来单位",
                                              dropdownMatchSelectWidth: false,
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            on: {
                                              search: _vm.handleSearchOrgan,
                                            },
                                            model: {
                                              value: _vm.queryParam.organId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "organId",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.organId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.organList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.supplier) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据日期",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-range-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            format: "YYYY-MM-DD",
                                            placeholder: [
                                              "开始日期",
                                              "结束日期",
                                            ],
                                          },
                                          on: { change: _vm.onDateChange },
                                          model: {
                                            value: _vm.queryParam.dateRange,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "dateRange",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.dateRange",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "table-page-search-submitButtons",
                                    },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.searchQuery },
                                        },
                                        [_vm._v("查询")]
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { "margin-left": "8px" },
                                          on: { click: _vm.searchReset },
                                        },
                                        [_vm._v("重置")]
                                      ),
                                      _vm.btnEnableList.indexOf("5") > -1
                                        ? _c(
                                            "a-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              attrs: { icon: "printer" },
                                              on: { click: _vm.handlePrint },
                                            },
                                            [_vm._v("打印")]
                                          )
                                        : _vm._e(),
                                      _vm.btnEnableList.indexOf("3") > -1
                                        ? _c(
                                            "a-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              attrs: { icon: "download" },
                                              on: { click: _vm.exportExcel },
                                            },
                                            [_vm._v("导出")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "a",
                                        {
                                          staticStyle: { "margin-left": "8px" },
                                          on: {
                                            click: function ($event) {
                                              _vm.toggleSearchStatus =
                                                !_vm.toggleSearchStatus
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.toggleSearchStatus
                                                  ? "收起"
                                                  : "展开"
                                              ) +
                                              "\n                    "
                                          ),
                                          _c("a-icon", {
                                            attrs: {
                                              type: _vm.toggleSearchStatus
                                                ? "up"
                                                : "down",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm.toggleSearchStatus
                              ? [
                                  _c(
                                    "a-row",
                                    { attrs: { gutter: 24 } },
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "财务人员",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  attrs: {
                                                    placeholder:
                                                      "请选择财务人员",
                                                    showSearch: "",
                                                    "allow-clear": "",
                                                    optionFilterProp:
                                                      "children",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam
                                                        .handsPersonId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "handsPersonId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.handsPersonId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.personList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: item.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(item.name) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "操作员",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  attrs: {
                                                    placeholder:
                                                      "请选择操作人员",
                                                    showSearch: "",
                                                    "allow-clear": "",
                                                    optionFilterProp:
                                                      "children",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam.creator,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "creator",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.creator",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.userList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: item.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              item.userName
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "账户信息",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  attrs: {
                                                    placeholder:
                                                      "请选择帐户信息",
                                                    showSearch: "",
                                                    "allow-clear": "",
                                                    optionFilterProp:
                                                      "children",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryParam.accountId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "accountId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.accountId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.accountList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: item.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(item.name) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "单据类别",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  attrs: {
                                                    placeholder:
                                                      "请选择单据类别",
                                                    "allow-clear": "",
                                                  },
                                                  on: {
                                                    change: _vm.onTypeChange,
                                                  },
                                                  model: {
                                                    value: _vm.queryParam.type,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryParam,
                                                        "type",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryParam.type",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: { value: "收款" },
                                                    },
                                                    [_vm._v("收款")]
                                                  ),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: { value: "付款" },
                                                    },
                                                    [_vm._v("付款")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "明细单号",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c("a-input", {
                                                attrs: {
                                                  placeholder:
                                                    "请输入采购或销售单号",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryParam.billNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryParam,
                                                      "billNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryParam.billNumber",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "备注",
                                                labelCol: _vm.labelCol,
                                                wrapperCol: _vm.wrapperCol,
                                              },
                                            },
                                            [
                                              _c("a-input", {
                                                attrs: {
                                                  placeholder: "请输入备注",
                                                },
                                                model: {
                                                  value: _vm.queryParam.remark,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryParam,
                                                      "remark",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryParam.remark",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.orgaTree.length
                                        ? _c(
                                            "a-col",
                                            { attrs: { md: 6, sm: 24 } },
                                            [
                                              _c(
                                                "a-form-item",
                                                {
                                                  attrs: {
                                                    label: "机构",
                                                    labelCol: _vm.labelCol,
                                                    wrapperCol: _vm.wrapperCol,
                                                  },
                                                },
                                                [
                                                  _c("a-tree-select", {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      "allow-clear": "",
                                                      treeData: _vm.orgaTree,
                                                      placeholder: "请选择机构",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.queryParam
                                                          .organizationId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.queryParam,
                                                          "organizationId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "queryParam.organizationId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "section",
                      { ref: "print", attrs: { id: "reportPrint" } },
                      [
                        _c("a-table", {
                          ref: "table",
                          attrs: {
                            bordered: "",
                            size: "middle",
                            rowKey: "rowIndex",
                            columns: _vm.columns,
                            dataSource: _vm.dataSource,
                            pagination: false,
                            scroll: _vm.scroll,
                            loading: _vm.loading,
                          },
                          on: { change: _vm.handleTableChange },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "billNoCustomRender",
                                fn: function (text, record) {
                                  return _c("span", {}, [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleBillNoClick(record)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(record.billNo))]
                                    ),
                                  ])
                                },
                              },
                              {
                                key: "billNumberCustomRender",
                                fn: function (text, record) {
                                  return _c("span", {}, [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleBillNumberClick(
                                              record
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(record.billNumber))]
                                    ),
                                  ])
                                },
                              },
                            ],
                            null,
                            false,
                            2020252555
                          ),
                        }),
                        _c(
                          "a-row",
                          {
                            staticStyle: {
                              "margin-top": "8px",
                              "text-align": "right",
                            },
                            attrs: { gutter: 24 },
                          },
                          [
                            _c(
                              "a-col",
                              { attrs: { md: 24, sm: 24 } },
                              [
                                _c("a-pagination", {
                                  attrs: {
                                    size: "small",
                                    "show-size-changer": "",
                                    "show-quick-jumper": "",
                                    current: _vm.ipagination.current,
                                    "page-size": _vm.ipagination.pageSize,
                                    "page-size-options":
                                      _vm.ipagination.pageSizeOptions,
                                    total: _vm.ipagination.total,
                                    "show-total": (total) => `共 ${total} 条`,
                                  },
                                  on: {
                                    change: _vm.paginationChange,
                                    showSizeChange:
                                      _vm.paginationShowSizeChange,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "buildOptionText",
                                        fn: function (props) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(props.value) + "条/页"
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    198454938
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.printMode
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "print-header",
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center",
                          padding: "8px 16px",
                          background: "#fff",
                          "border-bottom": "1px solid #e8e8e8",
                          "margin-bottom": "12px",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              "font-weight": "500",
                            },
                          },
                          [_vm._v(_vm._s(_vm.printTitle))]
                        ),
                        _c(
                          "a-button",
                          {
                            attrs: { icon: "close" },
                            on: {
                              click: function ($event) {
                                _vm.printMode = false
                              },
                            },
                          },
                          [_vm._v("关闭")]
                        ),
                      ],
                      1
                    ),
                    _c("ReportPrint", {
                      attrs: {
                        visible: true,
                        tableData: _vm.dataSource,
                        queryParam: _vm.queryParam,
                        billType: "MONEY_DETAIL",
                        billTypeName: "收付款明细",
                        buildData: _vm.buildPrintData,
                        embedded: true,
                      },
                      on: { "designer-change": _vm.onDesignerChange },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c("financial-detail", { ref: "financialDetail" }),
      _c("bill-detail", { ref: "billDetail" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }